// this.$store.state.mantenimiento
import { db } from "@/firebase";
import {
  doc,
  query,
  collection,
  where,
  getDocs,
  serverTimestamp,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import localforage from "localforage";
import moment from "moment";
import { colecciones } from "../constantes";

// MANTENIMIENTO
export const mantenimiento = {
  objeto: class {
    constructor() {
      return {
        id: "",
        idUsuario: "",
        idEmpresa: "",
        idVehiculo: "",
        idConductor: "",
        idResponsable: "",
        fecha: moment().format("YYYY-MM-DD"),
        tipo: "",
        causa: "",
        taller: "",
        descripcion: "",
        kilometraje: 0,
        evidencia: {
          nombre: "",
          tipo: "",
          url: "",
        },
        registro: {
          tipo: "Online",
          filtro: moment().format("YYYY-MM-DD"),
          realizacion: {
            fecha: moment().format("YYYY-MM-DD"),
            hora: moment().format("hh:mm:ss A"),
          },
          creacion: serverTimestamp(),
          actualizacion: serverTimestamp(),
          sincronizacion: serverTimestamp(),
          estado: "Creado",
        },
      };
    }
  },
  funciones: {
    async crear(mantenimiento, modoSinConexion, coleccion) {
      if (modoSinConexion) {
        mantenimiento.registro.tipo = "Offline";
        const obtenerRegistros = await localforage.getItem(
          coleccion
            ? coleccion
            : colecciones.localforage.seguridadVial.vehiculos.mantenimientos
              .registros,
        );
        const copia = obtenerRegistros
          ? JSON.parse(JSON.stringify(obtenerRegistros))
          : [];
        const registros = obtenerRegistros
          ? copia.concat([mantenimiento])
          : [mantenimiento];
        await localforage.setItem(
          coleccion
            ? coleccion
            : colecciones.localforage.seguridadVial.vehiculos.mantenimientos
              .registros,
          registros,
        );
      } else {
        await setDoc(
          doc(
            db,
            coleccion
              ? coleccion
              : colecciones.firebase.seguridadVial.vehiculos.mantenimientos
                .registros,
            mantenimiento.id,
          ),
          mantenimiento,
        );
      }
    },
    async actualizar(mantenimiento, modoSinConexion) {
      if (modoSinConexion) {
        const registros = await localforage.getItem(
          colecciones.localforage.seguridadVial.vehiculos.mantenimientos
            .registros,
        );
        const index = registros
          ? registros.findIndex((reg) => reg.id === mantenimiento.id)
          : -1;
        if (index !== -1) {
          registros[index] = mantenimiento;
          await localforage.setItem(
            colecciones.localforage.seguridadVial.vehiculos.mantenimientos
              .registros,
            registros,
          );
        }
      } else {
        await updateDoc(
          doc(
            db,
            colecciones.firebase.seguridadVial.vehiculos.mantenimientos
              .registros,
            mantenimiento.id,
          ),
          mantenimiento,
        );
      }
    },
    async eliminar(id, modoSinConexion) {
      if (modoSinConexion) {
        const registros = await localforage.getItem(
          colecciones.localforage.seguridadVial.vehiculos.mantenimientos
            .registros,
        );
        const index = registros
          ? registros.findIndex((reg) => reg.id === id)
          : -1;
        if (index !== -1) {
          registros.splice(index, 1);
          await localforage.setItem(
            colecciones.localforage.seguridadVial.vehiculos.mantenimientos
              .registros,
            registros,
          );
        }
      } else {
        await updateDoc(
          doc(
            db,
            colecciones.firebase.seguridadVial.vehiculos.mantenimientos
              .registros,
            id,
          ),
          {
            "registro.estado": "Eliminado",
            "registro.actualizacion": serverTimestamp(),
          },
        );
      }
    },
    async obtener(id, modoSinConexion) {
      if (modoSinConexion) {
        const registros = await localforage.getItem(
          colecciones.localforage.seguridadVial.vehiculos.mantenimientos
            .registros,
        );
        return registros ? registros.find((item) => item.id === id) : null;
      } else {
        const q = query(
          collection(
            db,
            colecciones.firebase.seguridadVial.vehiculos.mantenimientos
              .registros,
          ),
          where("id", "==", id),
          where("registro.estado", "in", ["Creado", "Editado"]),
        );
        const querySnapshot = await getDocs(q);
        return querySnapshot.docs.length > 0
          ? querySnapshot.docs[0].data()
          : null;
      }
    },
    async generarID() {
      const refMantenimiento = doc(
        collection(
          db,
          colecciones.firebase.seguridadVial.vehiculos.mantenimientos
            .registros,
        ),
      );
      return refMantenimiento.id;
    },
    descargarExcel(rows, nombre) {
      const XLSX = require("sheetjs-style");
      const wb = XLSX.utils.book_new();

      const headers = [
        [
          "FECHA REGISTRO",
          "FECHA MANTENIMIENTO",
          "PLACA",
          "TIPO",
          "KILOMETRAJE",
          "CAUSA",
          "DESCRIPCIÓN",
          "TALLER",
          "RESPONSABLE",
          "CONDUCTOR",
          "REGISTRADO POR",
          "EVIDENCIA",
        ],
      ];

      const ws = XLSX.utils.aoa_to_sheet(headers);

      const jsonData = rows.map((item) => ({
        fechaRegistro: item.fechas?.registro || "-",
        fechaMantenimiento: item.fechas?.mantenimiento || "-",
        placa: item.vehiculo?.placa || "-",
        tipo: item.tipo || "-",
        kilometraje: item.kilometraje || "-",
        causa: item.causa || "-",
        descripcion: item.descripcion || "-",
        taller: item.taller || "-",
        responsable: item.responsable || "-",
        conductor: item.conductor || "-",
        registradoPor: item.registradoPor || "-",
        evidencia: item.evidencia?.url ? "Ver Evidencia" : "-",
      }));

      const jsonHeaders = [
        "fechaRegistro",
        "fechaMantenimiento",
        "placa",
        "tipo",
        "kilometraje",
        "causa",
        "descripcion",
        "taller",
        "responsable",
        "conductor",
        "registradoPor",
        "evidencia",
      ];
      XLSX.utils.sheet_add_json(ws, jsonData, {
        origin: "A2",
        header: jsonHeaders,
        skipHeader: true,
      });

      ws["!cols"] = [
        { wch: 22 },
        { wch: 22 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 40 },
        { wch: 40 },
        { wch: 30 },
        { wch: 35 },
        { wch: 35 },
        { wch: 35 },
        { wch: 15 },
      ];

      /* ALTOS DE FILA — las columnas de texto largo expanden la fila */
      ws["!rows"] = [
        { hpt: 30 }, // fila de cabecera
        ...jsonData.map((row) => {
          const maxLen = Math.max(
            (row.causa || "").length,
            (row.descripcion || "").length,
            (row.taller || "").length,
          );
          return { hpt: maxLen > 60 ? 45 : 20 };
        }),
      ];

      /* Cabecera: fondo azul corporativo, texto blanco, negrita, centrado */
      const headerStyle = {
        font: {
          bold: true,
          sz: 11,
          name: "Calibri",
          color: { rgb: "F3F3F3" },
        },
        alignment: {
          horizontal: "center",
          vertical: "center",
          wrapText: true,
        },
        fill: { fgColor: { rgb: "073d7a" } },
        border: {
          top: { style: "thin", color: { rgb: "FFFFFF" } },
          bottom: { style: "thin", color: { rgb: "FFFFFF" } },
          left: { style: "thin", color: { rgb: "FFFFFF" } },
          right: { style: "thin", color: { rgb: "FFFFFF" } },
        },
      };
      /* Celdas de datos: bordes finos, fuente Arial, centrado */
      const cellStyle = {
        border: {
          top: { style: "thin", color: 1 },
          bottom: { style: "thin", color: 1 },
          left: { style: "thin", color: 1 },
          right: { style: "thin", color: 1 },
        },
        font: { name: "Arial", sz: 10, bold: false },
        alignment: {
          horizontal: "center",
          vertical: "center",
          wrapText: true,
        },
      };
      /* Tipo Preventivo: azul claro */
      const preventivoStyle = {
        fill: { fgColor: { rgb: "D6E4F7" } },
        font: { bold: true, color: { rgb: "073d7a" } },
      };
      /* Tipo Correctivo: rojo claro */
      const correctivoStyle = {
        fill: { fgColor: { rgb: "FAD7D7" } },
        font: { bold: true, color: { rgb: "C0392B" } },
      };
      /* Celdas de texto largo: alineación izquierda */
      const leftAlignStyle = {
        alignment: {
          horizontal: "left",
          vertical: "center",
          wrapText: true,
        },
      };
      /* APLICAR ESTILOS A CABECERAS */
      headers[0].forEach((_, C) => {
        const ref = XLSX.utils.encode_cell({ r: 0, c: C });
        if (!ws[ref]) ws[ref] = { t: "s", v: "" };
        ws[ref].s = headerStyle;
      });
      /* APLICAR ESTILOS A DATOS */
      jsonData.forEach((rowData, rowIndex) => {
        const excelRow = rowIndex + 1; // fila 0 = cabecera
        jsonHeaders.forEach((key, colIndex) => {
          const ref = XLSX.utils.encode_cell({ r: excelRow, c: colIndex });
          if (!ws[ref]) return;
          let style = { ...cellStyle };
          /* Colorear columna TIPO */
          if (key === "tipo") {
            if (rowData.tipo === "Preventivo") {
              style = { ...style, ...preventivoStyle };
            } else if (rowData.tipo === "Correctivo") {
              style = { ...style, ...correctivoStyle };
            }
          }
          /* Alinear a la izquierda los campos de texto libre */
          if (["causa", "descripcion", "taller"].includes(key)) {
            style = { ...style, ...leftAlignStyle };
          }
          ws[ref].s = style;
          /* Inyectar enlace a evidencia */
          const colEvidencia = jsonHeaders.indexOf("evidencia");
          rows.forEach((item, rowIndex) => {
            const excelRow = rowIndex + 1;
            const ref = XLSX.utils.encode_cell({
              r: excelRow,
              c: colEvidencia,
            });

            if (item.evidencia?.url) {
              ws[ref] = {
                t: "s",
                v: "Ver Evidencia",
                l: { Target: item.evidencia.url, Tooltip: "Ver Evidencia" },
                s: {
                  ...cellStyle,
                  font: {
                    name: "Arial",
                    sz: 10,
                    bold: true,
                    underline: true,
                    color: { rgb: "073d7a" },
                  },
                  alignment: {
                    horizontal: "center",
                    vertical: "center",
                  },
                },
              };
            }
          });
        });
      });

      XLSX.utils.book_append_sheet(wb, ws, "Mantenimientos");
      XLSX.writeFile(wb, `${nombre}.xlsx`);
    },
  },
};
